/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LoginStoreResponse } from '../models/login-store-response';
import { patchChangePassword } from '../fn/auth/patch-change-password';
import { PatchChangePassword$Params } from '../fn/auth/patch-change-password';
import { postLogin } from '../fn/auth/post-login';
import { PostLogin$Params } from '../fn/auth/post-login';


/**
 * Auth
 */
@Injectable({ providedIn: 'root' })
export class AuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postLogin()` */
  static readonly PostLoginPath = '/v1/login';

  /**
   * Create a session token.
   *
   * This will create a new session for the logged in user. Will invalidate all other active session tokens for that user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postLogin$Response(params: PostLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStoreResponse>> {
    return postLogin(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a session token.
   *
   * This will create a new session for the logged in user. Will invalidate all other active session tokens for that user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postLogin(params: PostLogin$Params, context?: HttpContext): Observable<LoginStoreResponse> {
    return this.postLogin$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginStoreResponse>): LoginStoreResponse => r.body)
    );
  }

  /** Path part for operation `patchChangePassword()` */
  static readonly PatchChangePasswordPath = '/v1/login';

  /**
   * change password.
   *
   * Set a new password as a logged in user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchChangePassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchChangePassword$Response(params: PatchChangePassword$Params, context?: HttpContext): Observable<StrictHttpResponse<LoginStoreResponse>> {
    return patchChangePassword(this.http, this.rootUrl, params, context);
  }

  /**
   * change password.
   *
   * Set a new password as a logged in user
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchChangePassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchChangePassword(params: PatchChangePassword$Params, context?: HttpContext): Observable<LoginStoreResponse> {
    return this.patchChangePassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<LoginStoreResponse>): LoginStoreResponse => r.body)
    );
  }

}
